import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import SuccessPage from "./pages/SuccessPage";
import CancelPage from "./pages/CancelPage";
import LandingPage from "./pages/LandingPage";
import Projects from "./pages/Projects";
import Result from "./components/Result";
import "./App.css";

function App() {
  return (
    <>
      <div className="app-wrapper">
        <Header />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/calculator" element={<HomePage />} />
          <Route path="/payment/success" element={<SuccessPage />} />
          <Route path="/payment/cancel" element={<CancelPage />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/result" element={<Result />} />
          <Route path="/result/hours" element={<Result />} />

          <Route path="*" element={<LandingPage />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
}

export default App;
